/**
 * @file: userOrderDetailPropsFromTaskContext.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  OrderDetailContextProps,
  OrderQrcodeUrlParams,
} from '@euler/app/flows/order/types';
import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useMemo } from 'react';

export const useOrderDetailPropsFromTaskContext = () => {
  const { taskNo, detail } = useTaskContext();
  const { taskService } = useServiceFactory();

  const getQrcodeImageUrl = useCallback(
    (params: OrderQrcodeUrlParams) => {
      return taskService.getSubscribeBindQrcodeImageUrl(taskNo, params);
    },
    [taskNo, taskService],
  );

  return useMemo<OrderDetailContextProps>(() => {
    const {
      basicInfo: {
        orderNo,
        licensePlateNo,
        vin,
        tags,
        vehicleMileage,
        vehicleName,
        vehicleBrandName,
        serviceAgentName,
        carwashType,
        reservationType,
        insuranceExpiryDate,
        returnType,
        oldPartDisposalType,
        estimatedFinishTime,
        customerType,
        customerName,
        customerMobile,
        dashboardImageUrl,
        signImgUrl,
        remark,
        orderDetail,
      },
    } = detail;
    return {
      orderNo,
      licensePlateNo,
      vin,
      tags,
      vehicleMileage,
      vehicleName,
      vehicleBrandName,
      serviceAgentName,
      carwashType,
      reservationType,
      insuranceExpiryDate,
      returnType,
      oldPartDisposalType,
      estimatedFinishTime,
      customerType,
      customerName,
      customerMobile,
      dashboardImageUrl:
        dashboardImageUrl ?? detail.preInspection.dashboardImgUrl,
      signImgUrl,
      remark,
      orderDetail,
      getQrcodeImageUrl,
      preInspection: detail.preInspection,
    };
  }, [detail, getQrcodeImageUrl]);
};
